 
import  { forwardRef, SVGProps } from 'react';
import LogoBotiaxSVG from '../Icons/logoBotiax';
type LogoProps = Omit<SVGProps<SVGSVGElement>, 'src'>;

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
const Logo = forwardRef<any, LogoProps>(
    ({ ...props }, ref) => {
        return <LogoBotiaxSVG ref={ref} {...props} />
    },
);

export default Logo;
